module.exports = __webpack_public_path__ + "img/collection-weddingRingsMorningGlow@2x.5b05e3f.jpg";